export enum EditorEventFilters {
    UNDO = "undo",
    REDO = "redo",
    GROUP = "group",
    UNGROUP = "ungroup",
    SUPERFICIAL = "superficial"
}

export {
    EditorEventFilters  as default,
}



// WEBPACK FOOTER //
// ./src/editor/ui/editor/EditorEventFilters.ts